import { render, staticRenderFns } from "./UserCalls.vue?vue&type=template&id=8e87aa1e&scoped=true&"
import script from "./UserCalls.vue?vue&type=script&lang=js&"
export * from "./UserCalls.vue?vue&type=script&lang=js&"
import style0 from "./UserCalls.vue?vue&type=style&index=0&id=8e87aa1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e87aa1e",
  null
  
)

export default component.exports